/**
 * The "made by VCNet" credit: the maker's mark, small, linking to vcnet.us.
 * Artwork like the utucat mark, so it is a file in `public/brand/` and never
 * redrawn. The file is dark ink on transparent; the stylesheet lightens it
 * in the dark theme. See docs/notes/brand.md.
 */
export function VcnetCredit() {
  return (
    <a className="vcnet-credit" href="https://vcnet.us" target="_blank" rel="noopener noreferrer">
      made by
      <img src="/brand/vcnet.png" alt="VCNet" width={1872} height={665} />
    </a>
  );
}
